const Atmosphere = {
  ATMOSPHERE_UPDATE: 'atmosphere/update',
};

export default Atmosphere;
